import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import {
  Title,
  TITLE_VARIANT_M,
  Panel,
  Grid,
  GridCell,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_SMALL_LIGHT,
  TEXT_VARIANT_BOLD_LIGHT,
  RadioButton,
  Select,
  MessageBox,
  MESSAGE_BOX_VARIANT_HELP,
  TEXT_VARIANT_LIGHT,
  ThumbContainer,
  SpacingVertical,
  SPACING_8,
  Icon60Trophy1,
  Flex,
  FlexItem
} from 'mailup-web-components'
import InputTags from 'Pages/AbTestWizard/components/step1/InputTags'

import { abTestState } from '../../recoil/state/abtest'

const BoxWinningMessage = () => {
  const intl = useIntl()
  const [{ step1 }, setAbTestState] = useRecoilState(abTestState)
  const criteriaList = [
    {
      value: 1,
      label: intl.formatMessage({ id: 'Load.ABTestWizard.Criteria1' })
    },
    {
      value: 2,
      label: intl.formatMessage({ id: 'Load.ABTestWizard.Criteria2' })
    }
  ]

  function onChangeTipoTest(value) {
    setAbTestState(prev => ({
      ...prev,
      step1: {
        ...prev.step1,
        tipoTest: value,
        step1IsDirty: true
      }
    }))
  }

  function onChangeCriterio(value) {
    setAbTestState(prev => ({
      ...prev,
      step1: {
        ...prev.step1,
        criterio: value,
        step1IsDirty: true
      }
    }))
  }

  function onInputTagChange(value) {
    setAbTestState(prev => ({
      ...prev,
      step1: {
        ...prev.step1,
        tags: value,
        step1IsDirty: true
      }
    }))
  }

  return (
    <>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.ABTestWizard.TitleWinner' })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Panel collapsible={false}>
        <Grid cols={5}>
          <GridCell span={1}>
            <ThumbContainer>
              <Flex
                justifyContent='center'
                alignItems='center'
                flex='0 1 auto'
                minHeight='250px'
                width='100%'
                className='winner-msg__container'
              >
                <FlexItem width='80%' minWidth='100px'>
                  <FlexItem
                    width='100px'
                    height='100px'
                    margin='0 auto 10px'
                    className={'winner-msg__icon'}
                  >
                    {step1.percTest < 100 && <Icon60Trophy1 />}
                  </FlexItem>

                  <Text variant={TEXT_VARIANT_BOLD_LIGHT}>
                    {intl.formatMessage({
                      id: 'Load.ABTestWizard.PlaceholderWinnerTitle'
                    })}
                  </Text>
                  {step1.percTest !== 100 && (
                    <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                      {intl.formatMessage({
                        id: 'Load.ABTestWizard.PlaceholderWinnerDescription'
                      })}
                    </Text>
                  )}
                  {step1.percTest === 100 && (
                    <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                      {intl.formatMessage({
                        id:
                          'Load.ABTestWizard.PlaceholderWinnerDescriptionDisable'
                      })}
                    </Text>
                  )}
                </FlexItem>
              </Flex>
            </ThumbContainer>
          </GridCell>
          <GridCell span={4}>
            <SpacingVertical variant={SPACING_8} />
            <Text
              variant={
                step1.percTest === 100
                  ? TEXT_VARIANT_BOLD_LIGHT
                  : TEXT_VARIANT_BOLD
              }
            >
              {intl.formatMessage(
                { id: 'Load.ABTestWizard.PickCriteriaTitle' },
                { perc: 100 - step1.percTest }
              )}
              {' *'}
            </Text>
            <SpacingVertical variant={SPACING_8} />

            <Flex
              margin='0 0 8px 0'
              alignItems='center'
              justifyContent='flex-start'
            >
              <FlexItem>
                <RadioButton
                  name='radioTipoTest'
                  label={intl.formatMessage({
                    id: 'Load.ABTestWizard.PickCriteriaRadioAutomatic'
                  })}
                  value='A'
                  checked={step1.tipoTest === 'A'}
                  onChange={() => onChangeTipoTest('A')}
                  data-mu-test='radio-abtest-auto'
                  disabled={step1.percTest === 100}
                  labelClassName='label-radio-button'
                />
              </FlexItem>
              <FlexItem width='30%'>
                <Select
                  disabled={step1.percTest === 100}
                  value={step1.criterio}
                  options={criteriaList}
                  searchable={false}
                  onChange={onChangeCriterio}
                  data-mu-test='select-abtest-criterio'
                />
              </FlexItem>
            </Flex>

            <RadioButton
              name='radioTipoTest'
              label={intl.formatMessage({
                id: 'Load.ABTestWizard.PickCriteriaRadioManual'
              })}
              value='M'
              checked={step1.tipoTest === 'M'}
              onChange={() => onChangeTipoTest('M')}
              data-mu-test='radio-abtest-manual'
              disabled={step1.percTest === 100}
              labelClassName='label-radio-button'
            />
            <SpacingVertical />
            <InputTags
              onChange={value => onInputTagChange(value)}
              idDisabled={step1.percTest === 100}
            />
          </GridCell>
        </Grid>
        {step1.percTest === 100 && (
          <>
            <SpacingVertical />
            <MessageBox variant={MESSAGE_BOX_VARIANT_HELP}>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.ABTestWizard.PlaceholderWinnerTooltipDisable'
                })}
              </Text>
            </MessageBox>
          </>
        )}
      </Panel>
    </>
  )
}

export default BoxWinningMessage
